<template>
  <div class="chat-element-text-top">
    <div class="left">
      <span>我：</span>
      <span>{{ content }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    messageItem: {
      type: Object,
    },
    content: {
      type: String,
    },
    date: {
      type: String,
    },
    attachmentList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    copy() {
      this.$copyText(this.content)
        .then((message) => {
          this.$message("复制成功");
        })
        .catch((err) => {
          this.$message.error("复制失败");
        });
    },
    doDelete() {
      this.$emit("delete", this.messageItem.id);
    },
  },
};
</script>

<style lang="less" scoped>
.chat-element-text-top {
  width: 100%;
  position: relative;
  display: flex;
  justify-content: flex-end;
  margin-top: 6px;
  margin-bottom: 6px;
  .left {
    max-width: calc(100% - 146px);
    display: flex;
    justify-content: end;
    font-family: "Microsoft YaHei";
    font-size: 12rpx;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.72px;
    opacity: 0.8;
    color: #fff;
  }
}
</style>
